import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import MapIcon from '@mui/icons-material/Map';
import { motion } from 'framer-motion';

const PageNotFound: React.FC = () => {
    const navigate = useNavigate();

    const handleDashboardRedirect = (): void => {
        navigate('/home'); // Navigate to the dashboard page
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                textAlign: 'center',
                backgroundColor: '#f5f5f5',
                padding: 2,
                overflow: 'hidden'
            }}
        >
            <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
            >
                <MapIcon sx={{ fontSize: 80, color: 'gray' }} />
            </motion.div>
            <motion.div
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.2 }}
            >
                <Typography variant="h2" color="error" gutterBottom>
                    404 - Page Not Found
                </Typography>
                <Typography variant="h6" color="textSecondary" gutterBottom>
                    Oops! The vehicle you're tracking seems to be lost.
                </Typography>
            </motion.div>
            <motion.div
                animate={{ x: [-5, 5, -5] }}
                transition={{ repeat: Infinity, duration: 1, ease: "easeInOut" }}
            >
                <DirectionsCarIcon sx={{ fontSize: 60, color: 'gray', marginBottom: 2 }} />
            </motion.div>
            <motion.div
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.4, delay: 0.6 }}
            >
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDashboardRedirect}
                    sx={{ marginTop: 2 }}
                >
                    Go to Dashboard
                </Button>
            </motion.div>
        </Box>
    );
};

export default PageNotFound;
